
/*--------------------------
    common
--------------------------*/
$(document).on('click','a[href^="#"]',function(){
  let href = $(this).attr("href");
  let target = $(href == "#" || href == "" ? 'html' : href);
  let position = target.offset().top;
  $('html,body').animate({ scrollTop: position }, 500, 'swing');
  return false;
})

/*--------------------------
    navigation
--------------------------*/
$(document).on('click','#btn',function(){
  toggleNav();
})

$(document).on('click','#layer',function(){
  toggleNav();
})

function toggleNav() {
  const btn = $('#btn');
  const nav = $('#nav');
  const gnavi = $('#gnavi');
  const layer = $('#layer');
  const parents = $('.parent-tab');
  const children = $('.gnavi__sp__nav__child');
  $([gnavi[0], nav[0], btn[0], layer[0]]).toggleClass('open');

  if(gnavi.hasClass('open') === false) {
    parents.removeClass('open');
    children.hide();
  }
};

$(document).on('click','.parent-tab',function(){
  $(this).toggleClass('open');
  $(this).next('.gnavi__sp__nav__child').slideToggle();
})

/*--------------------------
    search
--------------------------*/
$(document).on('click','.js--search',function(){
  $('.js--search--box').toggleClass('open');
})

/*--------------------------
    inview
--------------------------*/
function inview() {
    const fadeItems = document.querySelectorAll('.effect');
    const showElements = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-show');
        } else {
          entry.target.classList.remove('is-show');
        }
      } );
    }

    const options = {
        rootMargin: "0px 0px -14% 0px",
        threshold: 0, // [0-1]
    };
;
    const observer = new IntersectionObserver(showElements, options);
    fadeItems.forEach(item => {
      observer.observe(item);
    });
}

/* ----------------------------------------
	pagetop
---------------------------------------- */
$(window).scroll(function () {
  const pageTop = $('.sticky__nav');
  if ($(this).scrollTop() > 300) {
    pageTop.fadeIn('slow');
  } else {
    pageTop.fadeOut('slow');
  }
});


/*----------------------------------------
    FV
---------------------------------------- */
if($(".fv__slider").length > 0) {
  const fvOption = {
    loop: true,
    speed: 1000,
    fadeEffect: { crossFade: true },
    autoplay: {
        delay: 5000,
        disableOnInteraction: false
    },
    observer: true,
    spaceBetween: 20,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
      nextEl: '.fv-next',
      prevEl: '.fv-prev',
    },
  }

  new Swiper('.fv__slider', fvOption);
};

/*----------------------------------------
    common slider
---------------------------------------- */
if($(".common-slider").length > 0) {
  let sliderOption = {
    loop: true,
    speed: 1000,
    slidesPerView: 5,
    fadeEffect: { crossFade: true },
    autoplay: {
        delay: 3000,
        disableOnInteraction: false
    },
    observer: true,
    spaceBetween: 30,
    breakpoints: {
			650: {
        centeredSlides: true,
			  slidesPerView: 2.2,
        spaceBetween: 15,
			}
		}
  }
  $(".common-slider").each(function(i){
    sliderOption.navigation = {
      nextEl: '.common-slider-next' + i,
      prevEl: '.common-slider-prev' + i,
    };
    new Swiper("#" + $(this).attr('id'), sliderOption);
  })
};

/*----------------------------------------
    products slider
---------------------------------------- */
if ($(".main-slider").length > 0) {

  const windowWidth = $(window).width();
  const windowSm = 650;
  if (windowWidth <= windowSm) {
    //横幅650px以下
    const pSliderOption = {
      loop: true,
      speed: 600,
      pagination: {
        el: '.swiper-pagination',
        clickable: true, // ページネーションをクリック可能にする
      }
    }

    const pSlider = new Swiper(".main-slider", pSliderOption);
    $('.thumbnail-item').eq(0).addClass('--is-current');

    $('.thumbnail-item').click(function () {
      $('.thumbnail-item').removeClass('--is-current');
      $(this).addClass('--is-current');
      pSlider.slideTo($(this).data('num'));
    })
  } else {
    //横幅651px以上
    const pSliderOption = {
      effect: "fade",
      loop: true,
      speed: 1000,
      fadeEffect: {
        crossFade: true
      },
      allowTouchMove: false
    }

    const pSlider = new Swiper(".main-slider", pSliderOption);
    $('.thumbnail-item').eq(0).addClass('--is-current');

    $('.thumbnail-item').click(function () {
      $('.thumbnail-item').removeClass('--is-current');
      $(this).addClass('--is-current');
      pSlider.slideTo($(this).data('num'));
    })
  }
};


// if($(".main-slider").length > 0) {
//   const pSliderOption = {
//     effect: "fade",
//     loop: true,
//     speed: 1000,
//     fadeEffect: { crossFade: true },
//     allowTouchMove: false
//   }
//   const pSlider = new Swiper(".main-slider", pSliderOption);
//   $('.thumbnail-item').eq(0).addClass('--is-current');

//   $('.thumbnail-item').click(function(){
//     $('.thumbnail-item').removeClass('--is-current');
//     $(this).addClass('--is-current');
//     pSlider.slideTo($(this).data('num'));
//   })
// };


/*----------------------------------------
    tab
---------------------------------------- */
$('.js-tab-item').click(function(){
  $('.js-tab-item').removeClass('--is-active');
  $(this).addClass('--is-active');
  const target = $(this).attr('data-target');
  $('.js-tab-target').removeClass('--is-active');
  $('#' + target).addClass('--is-active');
});

/* ----------------------------------------
	toggle
---------------------------------------- */
$('.toggle--btn').click(function(){
  $(this).toggleClass('--is-open');
  $(this).next('.toggle--target').slideToggle();
});






// class QuantityInput extends HTMLElement {
// 	constructor() {
// 		super(), this.input = this.querySelector("input"), this.changeEvent = new Event(
// 				"change", {
// 					bubbles: !0
// 				}), this.input.addEventListener("change", this.onInputChange.bind(this)),
// 			this.querySelectorAll("button").forEach(button => button.addEventListener(
// 				"click", this.onButtonClick.bind(this)))
// 	}
// 	quantityUpdateUnsubscriber = void 0;
// 	disconnectedCallback() {
// 		this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber()
// 	}
// 	onInputChange(event) {
// 		this.validateQtyRules()
// 	}
// 	onButtonClick(event) {
// 		event.preventDefault();
// 		const previousValue = this.input.value;
// 		event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown(),
// 			previousValue !== this.input.value && this.input.dispatchEvent(this.changeEvent)
// 	}
// 	validateQtyRules() {
// 		const value = parseInt(this.input.value);
// 		if (this.input.min) {
// 			const min = parseInt(this.input.min);
// 			this.querySelector(".quantity__button[name='minus']").classList.toggle(
// 				"disabled", value <= min)
// 		}
// 		if (this.input.max) {
// 			const max = parseInt(this.input.max);
// 			this.querySelector(".quantity__button[name='plus']").classList.toggle(
// 				"disabled", value >= max)
// 		}
// 	}
// }
// customElements.define("quantity-input", QuantityInput);